<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-8
        h4.card-title.mb-0
          | User Manual for
          span.text-capitalize &nbsp;{{simulatedAccessLevel}}
        div.small.text-muted
          | Documentation for Enchatment
      div.col-sm-4.hidden-sm-down.text-right
        div(v-if='userAccessLevel != "agent"')
          b-btn(type='button', variant='primary', @click.stop='toggleAccessLevel()', v-if='simulatedAccessLevel!="agent"')
            | Agent View
          b-btn(type='button', variant='primary', @click.stop='toggleAccessLevel()', v-else)
            span.text-capitalize {{userAccessLevel}}
            | &nbsp;View
    br
    p <b>Enchatment</b> is a platform for admins/agents to monitor the company's performance, manage the bot and it contains various features such as&nbsp;
      span(v-if='simulatedAccessLevel != "agent"') Dashboard, 
      | Interactions, Customers, Broadcast, Training, Chat Flow and CRM.
    br
    // DASHBOARD
    div(v-if='simulatedAccessLevel != "agent"')
      h3 Dashboard
      hr
      p The Dashboard feature allows the agents to look at the overall performance of the bot.
      ol
        li At the top section, the agent will be able to see two boxes which records the statistics of <b>Total Customers</b> and <b>Total Interactions</b>. It will display the latest updates of the number of customers and the amount of interactions respectively.
        br
        img(src='static/img/ui/topcustomers.png', alt='Total Customers')
        br
        br
        img(src='/static/img/ui/topinteractions.png', alt='Total Interactions')
        br
        br
        li At the middle section, the agent will be able to view <b>Top Conversation Topics</b> which will have the 5 Most Interacted Topics that the customers have used during interaction with the bot. It also displays the Users Count and Interactions Count for the each specific topic. <br> At the top right of the table, an <b>Export</b> button will be available.&nbsp;
          span(v-if='simulatedAccessLevel != "agent"') Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.
          span(v-else) Agent will be able to download as PDF.
        br
        img(src='/static/img/ui/dashboard2.png', alt='Top Conversation Topics')
        br
        br
        li At the bottom section, the agent will be able to monitor <b>Real Time Interactions</b> with the 5 Most Recent Interactions. It displays the updated messages as they are being sent from every customer, including the timestamp that states the time of occurrence of the particular message. <br> At the top right of the table, an <b>Export</b> button will be available.&nbsp;
          span(v-if='simulatedAccessLevel != "agent"') Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.
          span(v-else) Agent will be able to download as PDF.
        br
        img(src='/static/img/ui/dashboard3.png', alt='Real Time Interactions')
      br
    // INTERACTIONS
    h3 Interactions
    hr
    p The Interactions feature is mainly to display the past interactions between the customers and the bot. It has a list of interactions which will be running in real-time for agents to know what is happening so that they are able to control the bot. There are two types of interactions: <b>Flagged</b> and <b>Unflagged</b>.
    p In every interaction, the replies that are being sent back to the customer will be from 2 different parties: <b>Bot</b> and <b>Live Agent</b>. Each types of the replies will be differentiated in colour variations:
    ol
      li Replies from <b>Bot</b> will be <i>blue</i> in colour.
      img(src='/static/img/ui/msg1.png', alt='Bot Message')
      br
      br
      li Replies from <b>Live Agent</b> will be <i>green</i> in colour.
      img(src='/static/img/ui/msg2.png', alt='Live Agent Message')
      // br
      // br
      // li Replies from <b>Campaign</b> will be <i>yellow</i> in colour.
    br
    h5 Unflagged
    p For the unflagged interactions, there are 3 different action buttons that the agents can perform towards every specific interaction: <b>Quicksend</b>, <b>History</b> and <b>Pause Autoreply</b>.
    img(src='/static/img/ui/actions.png', alt='Action Buttons')
    br
    br
    ol
      li Click on <b>Quicksend</b>. <br> The agent will be able to send messages instantly.
      img(src='/static/img/ui/quicksend.png', alt='Quicksend')
      br
      br
      li Click on <b>History</b>. <br> The agent will be able to view the history of the interaction.
      img(src='/static/img/ui/history.png', alt='History')
      br
      br
      li Click on <b>Pause Autoreply</b>. <br> The agent will be able to takeover the bot by pausing autoreply.
      img(src='/static/img/ui/pause.png', alt='Pause Autoreply')
    br
    p When a bot is paused, the whole chat box will be covered in a <b>red</b> border and it will be stated as <b>Agent Takeover Active</b>. However, the agent will be <b>disconnected</b> from the chat after 30 seconds of idle, but the 30 seconds timer will reset whenever the live agent is still replying to the customer.
    br
    img(src='/static/img/ui/takeover.png', alt='Takeover')
    br
    br
    p Whenever two agents are accessing the same interaction, the latter will receive a screen covered in red. This is because only one agent is able to access and takeover an interaction.
    br
    h5 Flagged
    p When the interactions in this section are highlighted in red colour, these are the interactions that are in need of attention for an agent to takeover. After 90 seconds, the flagged interactions will be changed back to unflagged if nothing happens to it (no takeover by agents). After pausing the bot, the input field is a <b>quicksend</b> function that can be used to instantly reply customers without pressing into the chat or button as it is faster to reply a flagged interaction.
    img(src='/static/img/ui/flagged.png', alt='Flagged')
    br
    br
    p At the top right of the table, an <b>Export</b> button will be available.&nbsp;
      span(v-if='simulatedAccessLevel != "agent"') Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.
      span(v-else) Agent will be able to download as PDF.
    img(src='/static/img/ui/export.png', alt='Export')
    br
    br
    p Click on <b>Pause Autoreply</b>. <br> The agent will be able to pause and resume <b>ALL</b> autoreplies of the bot for every single interaction.
    img(src='/static/img/ui/pauseautoreply.png', alt='Pause All')
    br
    br
    img(src='/static/img/ui/resume.png', alt='Resume All')
    br
    br
    // COMPLAINTS
    h3 Complaints
    hr
    p This is where all complaints are being sent that will notify the agent and it will display the names, messages of the complaint, ID, timestamps etc. The agent will be able to send an <b>email</b> to the user of the particular complaint to reply to their negative feedback.
    p Click on <b>Email</b>. <br> The agent will be redirected to a link to send out the email.
    img(src='/static/img/ui/email.png', alt='Email')
    br
    br
    p At the top right of the table, an <b>Export</b> button will be available.&nbsp;
      span(v-if='simulatedAccessLevel != "agent"') Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.
      span(v-else) Agent will be able to download as PDF.
    img(src='/static/img/ui/export.png', alt='Export')
</template>

<script>
// import Manual from '../manual.md'

export default {
  name: 'dashboard',
  data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel,
      simulatedAccessLevel: null,
    }
  },
  // render: h => h(Manual),
  mounted: function() {
    this.simulatedAccessLevel = this.userAccessLevel
  },
  methods: {
    toggleAccessLevel: function() {
      this.simulatedAccessLevel = (this.simulatedAccessLevel == 'agent') ? this.userAccessLevel : 'agent'
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Manual.vue?72826903